import { Col, Row } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';

const Disclaimer = ({ values, setFieldValue }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Disclaimer</h3>
        <p>Add a Disclaimer that would be displayed to the User. </p>
      </Col>
      <Col md={7} lg={7} sm={7}>
        <Row className="pt-2">
          <Col>
            <TextField
              style={{ borderColor: 'white' }}
              id="disclaimer"
              value={values.SelfAccountUnlockDisclaimer}
              //label="disclaimer"
              multiline
              rows={4}
              //defaultValue={resetDisclaimer}
              fullWidth
              variant="outlined"
              name="SelfAccountUnlockDisclaimer"
              onChange={(e) =>
                setFieldValue('SelfAccountUnlockDisclaimer', e.target.value)
              }
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Disclaimer;
